import { FINITE_STATE_OBSERVABLE_PRIVATE } from './privates';
import { EnumToString } from '../../../helpers';
export function GetFiniteStateObservableDefaultFinalStates() {
    return new Set(['complete', 'error']);
}
export function NormalizeFiniteStateObservableFinalStates(finalStates) {
    const defaultSet = GetFiniteStateObservableDefaultFinalStates();
    if (finalStates === void 0) {
        return defaultSet;
    }
    else if (Symbol.iterator in finalStates) {
        const _finalStates = new Set(finalStates);
        if (_finalStates.has('next')) {
            throw new TypeError(`finalStates must not contain 'next'`);
        }
        {
            const iterator = defaultSet.values();
            let result;
            while (!(result = iterator.next()).done) {
                if (!_finalStates.has(result.value)) {
                    throw new TypeError(`finalStates must contain '${result.value}'`);
                }
            }
        }
        {
            const iterator = _finalStates.values();
            let i = 0;
            let result;
            while (!(result = iterator.next()).done) {
                if (typeof result.value !== 'string') {
                    throw new TypeError(`Expected Iterable of string as finalStates, found '${result.value}' at index ${i}`);
                }
                i++;
            }
        }
        return _finalStates;
    }
    else {
        throw new TypeError(`Expected Iterable<TFinalState> or void as finalStates`);
    }
}
export function GetFiniteStateObservableDefaultModes() {
    return new Set(['once', 'uniq', 'cache', 'cache-final-state', 'cache-all']);
}
export function NormalizeFiniteStateObservableModes(modes) {
    const defaultSet = GetFiniteStateObservableDefaultModes();
    if (modes === void 0) {
        return defaultSet;
    }
    else if (Symbol.iterator in modes) {
        const _modes = new Set(modes);
        {
            const iterator = defaultSet.values();
            let result;
            while (!(result = iterator.next()).done) {
                if (!_modes.has(result.value)) {
                    throw new TypeError(`modes must contain '${result.value}'`);
                }
            }
        }
        {
            const iterator = _modes.values();
            let i = 0;
            let result;
            while (!(result = iterator.next()).done) {
                if (typeof result.value !== 'string') {
                    throw new TypeError(`Expected Iterable of string as modes, found '${result.value}' at index ${i}`);
                }
                i++;
            }
        }
        return _modes;
    }
    else {
        throw new TypeError(`Expected Iterable<TMode> or void as finalStates`);
    }
}
export function NormalizeFiniteStateObservableMode(modes, mode) {
    if (mode === void 0) {
        return 'once';
    }
    else if (modes.has(mode)) {
        return mode;
    }
    else {
        throw new TypeError(`Expected void or ${EnumToString(Array.from(modes))} as mode`);
    }
}
export function IsFiniteStateObservableFinalState(instance, name) {
    return instance[FINITE_STATE_OBSERVABLE_PRIVATE].finalStates.has(name);
}
export function IsFiniteStateObservableNextState(name) {
    return (name === 'next');
}
export function IsFiniteStateObservableCachingValuesMode(mode) {
    return ((mode === 'cache')
        || (mode === 'cache-final-state')
        || (mode === 'cache-all'));
}
export function IsFiniteStateObservableCachingValues(instance) {
    return IsFiniteStateObservableCachingValuesMode(instance[FINITE_STATE_OBSERVABLE_PRIVATE].mode);
}
export function ThrowFiniteStateObservableCannotEmitAfterFiniteState(state, notificationName) {
    throw new Error(`Cannot emit a notification with the name '${notificationName}' when the observable is in a final state '${state}'`);
}
export function FiniteStateObservableOnEmit(instance, notification) {
    const privates = instance[FINITE_STATE_OBSERVABLE_PRIVATE];
    const isFinalState = IsFiniteStateObservableFinalState(instance, notification.name);
    if (isFinalState || IsFiniteStateObservableNextState(notification.name)) {
        if (privates.state === 'next') {
            if ((privates.mode === 'cache')
                || (privates.mode === 'cache-all')
                || ((privates.mode === 'cache-final-state')
                    && isFinalState)) {
                privates.values.push(notification);
            }
            if (isFinalState) {
                privates.state = notification.name;
            }
        }
        else {
            ThrowFiniteStateObservableCannotEmitAfterFiniteState(privates.state, notification.name);
        }
    }
    else {
        if (privates.mode === 'cache-all') {
            privates.values.push(notification);
        }
    }
}
export function FiniteStateObservableClearCache(instance) {
    const privates = instance[FINITE_STATE_OBSERVABLE_PRIVATE];
    if (privates.state !== 'next') {
        throw new Error(`Clearing FiniteStateObservable's cache may only be performed when its state is 'next'`);
    }
    else if (instance.observed) {
        throw new Error(`Clearing FiniteStateObservable's cache may only be performed when it is not observed`);
    }
    else {
        privates.values = [];
    }
}
//# sourceMappingURL=functions.js.map